
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { FormWizard, TabContent } from "vue-form-wizard";
import { SweetModal } from "sweet-modal-vue";
import AttachImage from '@/modules/Media/Attach.vue';
import { showToaster } from '@/components/DashboardComposer/helpers';
import DigitalSignageModule from '@/stores/modules/DigitalSignage';
import AttachItem from '@/modules/Packages/Attachpackageitem.vue';
import NevronIcons from "@/components/NevronIcons.vue";
import draggable from 'vuedraggable';
import {Setting} from "@/stores/Setting";
import stores from "@/stores";
import TableGeneric from "@/components/NevronTableGeneric.vue";
import TableModalGeneric from "@/components/NevronTableModalGeneric.vue";
import {capitalizeFirst, translate} from "@/helpers/functions";
// @ts-ignore
import Switches from 'vue-switches';

@Component({
  methods: {
    translate,
    capitalizeFirst,
    getMinDate() {
      const now = new Date();
      const timeZoneOffset = now.getTimezoneOffset();
      return new Date(now.getTime() - timeZoneOffset * 60 * 1000).toISOString().slice(0, 16);
    }
  },
  components: {
    TableModalGeneric,
    TableGeneric,
    NevronIcons,
    FormWizard,
    TabContent,
    SweetModal,
    AttachImage,
    AttachItem,
    draggable,
    Switches,
  }
})


export default class CreatePlaylist extends Vue {
  @Prop()
  module!: DigitalSignageModule;

  // Non-null when editing a playlist
  @Prop({ default: null })
  item!: IPlaylist | null;

  playlist: IPlaylist = this.initializePlaylist();
  playlistElements: IPlaylistElement[] = [];
  selectedIndex!: number;

  displayOptionFrom: string = 'fixed';
  displayOptionTo: string = this.playlist.displayInfinitely ? 'infinite' : 'fixed';

  videoExtensions = ['mp4', 'avi', 'mov', 'webm'];
  photoExtensions = ['jpg', 'jpeg', 'png', 'svg'];

  settings: { [key: string]: Setting } = {
    durationImages: new Setting({'key': 'module-type.DIGITAL_SIGNAGE.durationImages'}),
    durationTv: new Setting({'key': 'module-type.DIGITAL_SIGNAGE.durationTv'}),
    durationUrls: new Setting({'key': 'module-type.DIGITAL_SIGNAGE.durationUrls'}),
    hasImages: new Setting({'key': 'module-type.DIGITAL_SIGNAGE.hasImages'}),
    hasTv: new Setting({'key': 'module-type.DIGITAL_SIGNAGE.hasTv'}),
    hasUrls: new Setting({'key': 'module-type.DIGITAL_SIGNAGE.hasUrls'}),
    defaultTransition: new Setting({'key': 'module-type.DIGITAL_SIGNAGE.defaultTransition'}),

  };

  stores = stores;

  wizardKey = 0;

  get isEditMode() {
    return this.item !== null;
  }

  get playlistOrientationOptions() {
    return [
      {value: 'Portrait', label: 'Portrait', iconClass: 'screenPortrait'},
      {value: 'Landscape', label: 'Landscape', iconClass: 'screenLandscape'},
    ]
  }

  get playlistMediaTypes() {
    const baseOptions = [];
    if (this.hasElementOfType('MEDIA_LIBRARY') || this.settings.hasImages.value) {
      baseOptions.push({name: 'media-library', value: 'MEDIA_LIBRARY'});
    }
    if (this.playlist.orientation === 'Landscape' && (this.hasElementOfType('CHANNEL') || this.settings.hasTv.value)) {
      baseOptions.push({name: 'tv-channel', value: 'CHANNEL'});
    }
    if (this.hasElementOfType('URL') || this.settings.hasUrls.value) {
      baseOptions.push({name: 'web-link', value: 'URL'});
    }
    if (this.hasElementOfType('URL') || this.settings.defaultTransition.value) {
      baseOptions.push({name: 'url', value: 'URL'});
    }
    return baseOptions;
  }

  hasElementOfType(type: string) {
    return this.playlistElements.some(element => element.type === type);
  }

  get elementTransitionFromOptions() {
    return [
      { value: 'NONE', icon: 'bx bx-x' },
      { value: 'LEFT', icon: 'bx bxs-right-arrow-square' },
      { value: 'RIGHT', icon: 'bx bxs-left-arrow-square' },
      { value: 'TOP', icon: 'bx bxs-up-arrow-square' },
      { value: 'BOTTOM', icon: 'bx bxs-down-arrow-square' },
    ]
  }

  created() {
    stores.Setting.getSettings()
      .then((response) => {
        Object.keys(this.settings).forEach((key) => {
          const setting = this.settings[key];
          const responseSetting = response.find((s: ISetting) => s.key === setting.key);
          if (responseSetting) {
            Object.assign(setting, {
              value: responseSetting.value,
              type: responseSetting.type,
              id: responseSetting.id,
            });
          }
        });
      });
    this.setOnDisplayStart();
    this.setOnDisplayTo();
  }

  @Watch('item')
  onPlaylistIdChange() {
    this.resetComponent();
    if (!this.item || !this.item.id) {
      return;
    }
    this.playlist = JSON.parse(JSON.stringify(this.item));
    this.playlistElements = this.playlist.elements || [];
  }

  setOnDisplayStart() {
    if (this.displayOptionFrom === 'now') {
      const now = new Date();
      const timeZoneOffset = now.getTimezoneOffset();
      this.playlist.onDisplayStart = new Date(now.getTime() - timeZoneOffset * 60 * 1000).toISOString().slice(0, 16);
      this.playlist.status = 'Live';
    } else {
      this.playlist.status = 'Scheduled';
    }
  }

  setOnDisplayTo() {
    if (this.displayOptionTo === 'infinite') {
      this.playlist.onDisplayEnd = '';
      this.playlist.displayInfinitely = true;
    } else {
      this.playlist.displayInfinitely = false;
    }
  }

  @Watch('displayOptionFrom')
  onDisplayOptionFromChange() {
    this.setOnDisplayStart();
  }

  @Watch('displayOptionTo')
  onDisplayOptionToChange() {
    this.setOnDisplayTo();
  }

  visiblePlaylistMediaTypes(index: number) {
    let allTypes = [
      {name: 'media-library', value: 'MEDIA_LIBRARY'},
      {name: 'tv-channel', value: 'CHANNEL'},
      {name: 'web-link', value: 'URL'},
    ];
    const element = this.playlistElements[index];
    if (!this.settings.hasImages.value && element.type !== 'MEDIA_LIBRARY') {
      allTypes = allTypes.filter((type) => type.value !== 'MEDIA_LIBRARY');
    }
    if (!this.settings.hasUrls.value && element.type !== 'URL') {
      allTypes = allTypes.filter((type) => type.value !== 'URL');
    }
    if (this.playlist.orientation === 'Portrait' || (!this.settings.hasTv.value && element.type !== 'CHANNEL')) {
      allTypes = allTypes.filter((type) => type.value !== 'CHANNEL');
    }
    return allTypes;
  }

  elementTypeChange(index:number) {
    const element = this.playlistElements[index];
    switch (element.type) {
      case 'URL':
        element.duration = this.settings.durationUrls.value;
        break;
      case 'MEDIA_LIBRARY':
        element.duration = this.settings.durationImages.value;
        break;
      case 'CHANNEL':
        element.duration = this.settings.durationTv.value;
        break;
    }
  }

  getFileType(media: any) {
    if (media && this.videoExtensions.includes(media.type.toLowerCase())) {
      return 'video';
    } else if (media && this.photoExtensions.includes(media.type.toLowerCase())) {
      return 'photo';
    } else {
      return 'unknown';
    }
  }

  validateForm(formRef: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.$forceUpdate();
      this.$nextTick(() => {
        const form = this.$refs[formRef] as HTMLFormElement;
        form.classList.add('was-validated');
        resolve(form.checkValidity());
      });
    });
  }

  addElementInPlaylist() {
    this.playlistElements.push({
      id: null,
      type: null,
      channelId: null,
      mediaItemId: null,
      duration: null,
      url: null,
      mediaItem: null,
      channel: null,
      transitionFrom:  this.settings.defaultTransition.value,
      sort: this.playlistElements.length,
    });
  }

  attachMediaItem(result: any) {
    const mediaObject = result.result;
    if (mediaObject) {
      this.playlistElements[this.selectedIndex].mediaItemId = mediaObject.id;
      this.playlistElements[this.selectedIndex].mediaItem = mediaObject;
    }
  }

  attachSelectedChannel(channel: IChannel) {
    if (channel) {
      this.playlistElements[this.selectedIndex].channelId = channel.id;
      this.playlistElements[this.selectedIndex].channel = channel;
    }
  }

  attachDeviceGroups(deviceGroups: IDeviceGroup[]) {
    const union = deviceGroups.concat(this.playlist.deviceGroups.filter((item: IDeviceGroup) => {
      return deviceGroups.findIndex((item2: IDeviceGroup) => item.id === item2.id) < 0;
    }));
    this.playlist.deviceGroups = union;
  }

  detachDeviceGroup(deviceGroup: IDeviceGroup) {
    this.playlist.deviceGroups = this.playlist.deviceGroups.filter((item: IDeviceGroup) => item.id !== deviceGroup.id);
  }

  removeElement(index: number) {
    this.playlistElements.splice(index, 1);
    this.updateSort();
  }

  copyElement(index: number) {
    const element = this.playlistElements[index];
    this.playlistElements.push({
      ...element,
      id: null,
      sort: this.playlistElements.length,
    });
  }

  openMediaLibrary(index: number) {
    this.selectedIndex = index;
    // @ts-ignore
    this.$refs.mediaLibrary.$children[0].open();
  }

  openAttachChannel(index: number) {
    this.selectedIndex = index;
    // @ts-ignore
    this.$refs.attachChannel.$children[0].open();
  }

  saveAsDraft() {
    if (!this.validateForm('formStep1')) {
      return;
    }
    this.playlist.status = 'Draft';
    this.onSubmit();
  }

  onSubmit() {
    this.playlistElements = this.playlistElements.filter(element => !!element.type);

    // Change back to scheduled, if fixed start date
    if (this.displayOptionFrom === 'fixed') {
      this.playlist.status = 'Scheduled';
    }

    const playlist = {
      ...this.playlist,
      elements: this.playlistElements,
    };

    // Validation when playlist is not in draft mode
    if (this.playlist.status !== 'Draft') {
    }

    const savePromise = (this.isEditMode && playlist.id)
      ? this.module.updateItem(playlist.id, playlist)
      : this.module.createNewItem(playlist);

    savePromise.then((response) => {
      if (!response || !response.success) {
        // If the response is not successful, throw an error to go into catch block
        throw new Error(response.error.message);
      }
      const message = this.isEditMode ? Vue.prototype.translate('successfully-updated') : Vue.prototype.translate('successfully-created');
      showToaster('success', Vue.prototype.translate('playlist'), message);
      const eventToEmit = this.isEditMode ? 'save' : 'created';
      this.$emit(eventToEmit, true);
      this.cancel();
    })
      .catch((error) => {
        // Display the error message in the toaster
        showToaster('danger', Vue.prototype.translate('error')+ ':', error.message);
      });
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
    this.resetComponent();
  }

  initializePlaylist(): IPlaylist {

    return {
      id: 0,
      title: '',
      orientation: 'Portrait',
      status: 'Scheduled',
      onDisplayStart: null,
      onDisplayEnd: null,
      displayInfinitely: false,
      active: true,
      storeToDevice: false,
      elements: [],
      deviceGroups: [],
    } as IPlaylist;
  }

  resetComponent() {
    this.playlist = this.initializePlaylist();
    this.playlistElements = [];
    this.selectedIndex = 0;
    this.$el.querySelectorAll('.was-validated').forEach((form) => {
      form.classList.remove('was-validated');
    });
    this.wizardKey += 1;
    this.displayOptionFrom = 'fixed';
    this.displayOptionTo = 'fixed';
  }

  updateSort() {
    this.playlistElements.forEach((element, index) => {
      element.sort = index;
    });
  }

  get orientationImage() {
    if (this.playlist.orientation === 'Landscape') {
      return {value: 'Landscape', label: 'Landscape', iconClass: 'screenLandscape'};
    } else if (this.playlist.orientation === 'Portrait') {
      return  {value: 'Portrait', label: 'Portrait', iconClass: 'screenPortrait'};
    }
  }

  @Watch('playlist.displayInfinitely')
  onDisplayInfinitelyChange(newValue: boolean, oldValue: boolean) {
    const onDisplayEndInput = this.$el.querySelector('#on_display_end') as HTMLInputElement;
    if (onDisplayEndInput) {
      if (newValue === true) {
        this.playlist.onDisplayEnd = null;
        this.playlist.displayInfinitely = true;
        onDisplayEndInput.removeAttribute('required');
        onDisplayEndInput.setAttribute('disabled', 'disabled');
      } else {
        this.playlist.displayInfinitely = false;
        onDisplayEndInput.setAttribute('required', 'required');
        onDisplayEndInput.removeAttribute('disabled');
      }
    }
  }

  get formattedDate() {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    const startDate = this.playlist.onDisplayStart ? new Date(this.playlist.onDisplayStart).toLocaleString(undefined, options) : null;
    const endDate = this.playlist.onDisplayEnd ? new Date(this.playlist.onDisplayEnd).toLocaleString(undefined, options) : null;

    return {
      startDate: startDate,
      endDate: endDate
    };
  }
}
